if (!customElements.get("td-accordion-wrapper")) {
  class TdAccordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.items = this.querySelectorAll(".td-accordion__item");
      this.onlyOneActive = false;
    }

    connectedCallback() {
      this.bindEvents();
    }

    bindEvents() {
      const el = this;
      this.items.forEach(function (item) {
        const toggle = item.querySelector(".td-accordion__toggle");
        if (toggle) {
          toggle.addEventListener("click", function (event) {
            event.preventDefault();
            if (item.dataset.item) {
              el.toggle(item.dataset.item);
            }
          });
          if (item.dataset.open) {
            if (item.dataset.item) {
              el.toggle(item.dataset.item);
            }
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault();
            if (item.dataset.item) {
              el.toggle(String(parseInt(item.dataset.item) + 1));
            }
          });
        }
      });
    }

    toggle(currentItem) {
      const el = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".td-accordion__content");
        if (!content) return;
        
        if (item.dataset.item == currentItem) {
          if (item.classList.contains("is-active")) {
            // Closing - set to null immediately for smooth close
            content.style.maxHeight = null;
            item.classList.remove("is-active");
          } else {
            // Opening - add active class first, then calculate height
            item.classList.add("is-active");
            // Use requestAnimationFrame for better timing
            requestAnimationFrame(function() {
              content.style.maxHeight = content.scrollHeight + "px";
            });
          }
        } else if (el.onlyOneActive) {
          item.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define("td-accordion-wrapper", TdAccordion);
}
